import { render, staticRenderFns } from "./UserManagerAddUser.vue?vue&type=template&id=24680ce6&scoped=true"
import script from "./UserManagerAddUser.vue?vue&type=script&lang=js"
export * from "./UserManagerAddUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24680ce6",
  null
  
)

export default component.exports